var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiedBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 51.535 612 484",
    style: {
      enableBackground: "new 0 51.535 612 484"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SIED"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M180.89,360.043l1.453,28.198l-1.965,0.085 c-0.741-4.785-1.965-8.744-3.674-11.877c-1.709-3.132-4.187-5.896-7.434-8.289c-2.678-1.993-5.84-3.403-9.485-4.229 c-3.646-0.825-8.489-1.239-14.526-1.239H125.69v51.27h5.127c5.183,0,9.085-0.342,11.707-1.025c2.62-0.684,4.756-1.907,6.409-3.674 c1.594-1.651,2.777-3.603,3.546-5.854c0.77-2.25,1.41-5.568,1.923-9.955l1.965,0.085l-0.342,45.801h-1.965 c-0.513-4.386-1.269-7.918-2.265-10.596c-0.997-2.677-2.379-4.956-4.144-6.836c-1.709-1.822-3.931-3.162-6.665-4.017 s-6.21-1.281-10.425-1.281h-4.871v19.567c0,7.806,0.199,13.488,0.598,17.047c0.398,3.562,1.167,6.537,2.307,8.93 c1.936,4.102,4.884,7.107,8.844,9.015c3.959,1.91,9.186,2.863,15.68,2.863c6.836,0,12.561-0.868,17.175-2.606 c4.614-1.737,8.374-4.429,11.279-8.075c2.051-2.448,3.717-5.24,4.999-8.374c1.281-3.132,2.463-7.263,3.546-12.39l1.965,0.085 l-1.111,34.009H89.032v-1.965c3.247-0.171,5.881-0.626,7.904-1.367c2.021-0.74,3.831-1.937,5.426-3.589 c1.765-1.822,2.976-4.145,3.631-6.965c0.654-2.819,0.983-7.135,0.983-12.945v-62.976c0-5.811-0.329-10.125-0.983-12.946 c-0.655-2.819-1.866-5.14-3.631-6.964c-1.538-1.651-3.319-2.848-5.34-3.589c-2.023-0.74-4.687-1.196-7.99-1.367v-1.965 L180.89,360.043L180.89,360.043z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M383.566,474.716 c3.303-0.171,5.951-0.626,7.946-1.367c1.993-0.74,3.788-1.937,5.384-3.589c1.765-1.822,2.976-4.145,3.631-6.965 c0.654-2.819,0.982-7.135,0.982-12.945v-62.976c0-6.266-0.384-10.852-1.153-13.757s-2.265-5.298-4.485-7.178 c-2.792-2.335-6.894-3.645-12.305-3.931v-1.965h46.996c10.426,0,17.061,0.115,19.91,0.342c12.019,0.912,22.217,4.33,30.591,10.254 c7.975,5.64,14.185,13.031,18.628,22.174s6.665,19.098,6.665,29.864c0,7.861-1.269,15.282-3.803,22.26 c-2.535,6.979-6.054,12.774-10.553,17.389c-6.323,6.494-14.214,10.625-23.669,12.391c-7.064,1.311-14.271,1.965-21.619,1.965 h-63.146L383.566,474.716L383.566,474.716z M420.224,362.692v84.937c0,5.584,0.313,9.827,0.94,12.732 c0.626,2.905,1.794,5.383,3.503,7.434c3.645,4.443,9.57,6.665,17.773,6.665c7.007,0,13.002-1.153,17.987-3.461 c4.983-2.307,9.441-6.052,13.373-11.236c3.873-5.012,6.82-10.752,8.844-17.218c2.021-6.465,3.033-13.344,3.033-20.636 c0-8.089-1.226-15.779-3.674-23.072c-2.45-7.291-5.954-13.672-10.511-19.141c-6.323-7.576-13.872-12.589-22.644-15.039 c-4.785-1.31-10.882-1.965-18.287-1.965L420.224,362.692L420.224,362.692z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M97.535,311.197l0.312-42.954l2.392,0.104 c2.912,10.93,6.378,19.542,10.4,25.835c7.557,11.621,17.057,17.43,28.497,17.43c7.973,0,14.561-2.668,19.761-8.008 c5.2-5.338,7.8-12.099,7.8-20.281c0-3.536-0.572-7.141-1.716-10.816c-1.144-3.674-2.688-6.829-4.628-9.464 c-2.012-2.704-4.836-5.304-8.477-7.8c-3.64-2.496-9.204-5.65-16.692-9.464c-6.588-3.328-11.632-6.136-15.133-8.424 c-3.502-2.288-6.328-4.61-8.476-6.968c-5.964-6.517-8.944-14.457-8.944-23.817c0-5.754,1.16-11.301,3.484-16.641 c2.322-5.338,5.564-9.915,9.725-13.729c7.349-6.794,16.051-10.192,26.105-10.192c3.258,0,6.274,0.33,9.048,0.988 c2.772,0.66,6.482,1.959,11.128,3.9c3.466,1.388,5.824,2.272,7.072,2.652c1.248,0.382,2.356,0.572,3.328,0.572 c2.426,0,4.056-1.768,4.888-5.304h2.392l0.728,41.29h-2.392c-1.869-6.586-3.479-11.63-4.828-15.133 c-1.351-3.5-2.959-6.742-4.828-9.724c-3.392-5.408-7.129-9.413-11.213-12.012c-4.083-2.601-8.79-3.9-14.119-3.9 c-7.753,0-13.878,2.638-18.376,7.913c-1.869,2.151-3.341,4.685-4.414,7.6c-1.073,2.916-1.609,5.829-1.609,8.745 c0,11.591,7.443,20.928,22.328,28.006l14.642,7.079c11.284,5.345,19.419,11.244,24.405,17.699 c5.676,7.218,8.515,15.617,8.515,25.195c0,6.364-1.284,12.451-3.848,18.261c-3.606,8.093-9.014,14.336-16.225,18.729 c-7.212,4.391-15.705,6.588-25.481,6.588c-8.944,0-17.542-1.768-25.793-5.304c-4.3-1.872-6.864-2.946-7.696-3.224 c-0.832-0.276-1.768-0.416-2.808-0.416c-3.328,0-5.616,1.664-6.864,4.992h-2.39V311.197z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M477.352,169.648v2.392 c-3.952,0.208-7.16,0.764-9.62,1.664c-2.462,0.902-4.664,2.358-6.604,4.368c-2.704,2.774-4.368,6.622-4.992,11.544 c-0.416,3.676-0.624,7.904-0.624,12.688v76.651c0,5.756,0.276,10.296,0.832,13.625c0.554,3.328,1.456,5.998,2.704,8.008 c1.802,2.774,4.124,4.836,6.969,6.188c2.842,1.352,6.62,2.167,11.336,2.444v2.392h-66.459v-2.392 c4.021-0.208,7.263-0.78,9.725-1.716c2.461-0.936,4.629-2.374,6.5-4.316c2.219-2.218,3.709-5.026,4.473-8.424 c0.762-3.396,1.145-8.667,1.145-15.809v-76.65c0-7.141-0.383-12.411-1.145-15.809c-0.764-3.396-2.254-6.205-4.473-8.424 c-1.871-2.01-4.056-3.466-6.552-4.368c-2.496-0.9-5.72-1.456-9.673-1.664v-2.392C410.894,169.648,477.352,169.648,477.352,169.648 z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_11_",
    style: {
      fill: "none",
      stroke: "#A5A4A4",
      strokeMiterlimit: 10
    },
    x1: 62.859,
    y1: 338.023,
    x2: 525.081,
    y2: 338.023
  })), /*#__PURE__*/React.createElement("g", {
    id: "All_The_World_Inside",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 73.328,
    y: 607.61,
    style: {
      display: "inline",
      fill: "none"
    },
    width: 462.222,
    height: 146.283
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 283.3962 635.5774)",
    style: {
      display: "inline",
      fill: "#211F1F",
      fontFamily: "'CenturyGothic'",
      fontSize: 38
    }
  }, "all"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 283.3962 635.5774)",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10,
      fontFamily: "'CenturyGothic'",
      fontSize: 38
    }
  }, "all"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 248.8452 682.5774)",
    style: {
      display: "inline",
      fill: "#211F1F",
      fontFamily: "'CenturyGothic'",
      fontSize: 37
    }
  }, "worlds "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 248.8452 682.5774)",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10,
      fontFamily: "'CenturyGothic'",
      fontSize: 37
    }
  }, "worlds "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 238.7422 729.5774)",
    style: {
      display: "inline",
      fill: "#211F1F",
      fontFamily: "'CenturyGothic'",
      fontSize: 42,
      letterSpacing: 2
    }
  }, "inside"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 238.7422 729.5774)",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10,
      fontFamily: "'CenturyGothic'",
      fontSize: 42,
      letterSpacing: 2
    }
  }, "inside"), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#050606",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M87,690.365 c6.344-9.532,79.393-115.218,214-117.772c140.864-2.673,218.869,110.069,224,117.772"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Seed",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    style: {
      fill: "#F9F9FA"
    },
    d: "M283.014,126.632c16.145-17.658,12.216-95.963,33.333-31.333 s22.04,16.131,29.333,30c27.957,53.167,53.743,102.206,43.333,167.333c-5.622,35.17-16.309,40.688-35.679,88.667 c-20.933,51.852-43.46,133.333-36.887,160c6.572,26.667-16.777-7.446-22.767-20.667c-4.417-9.749-6.732-24.611,0-34 c2.166-3.021,4.68-4.667,7.333-10c2.381-4.786,3.22-9.217,4-13.333c0.601-3.171,1.384-7.306,1.333-12.667 c-0.064-6.835-1.444-12.147-4-20c-2.714-8.337-6.288-19.32-10.325-27.703c-11.87-24.651-42.074-56.598-47-62 c-41.1-45.072-49.16-135.736-15.341-173.63C247.228,147.638,261.917,149.706,283.014,126.632z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    style: {
      fill: "#EDEDED"
    },
    d: "M283.497,127.029c7.493-8.51,9.359-21.939,11.678-32.63 c1.285-5.923,2.339-11.999,4.309-17.744c1.001-2.92,2.764-7.943,6.181-4.527c5.169,5.168,7.408,15.144,9.621,21.778 c3.224,9.665,6.3,19.649,11.221,28.625c2.34,4.267,6.707,11.011,11.643,5.945c1.202-1.234,2.468-4.394,4.148-4.969 c1.119-0.383,1.237-0.017,2.085,0.744c1.432,1.284,2.222,4.015,3.096,5.679c1.552,2.957,3.103,5.915,4.643,8.878 c11.186,21.523,21.987,43.413,29.307,66.6c13.115,41.541,13.485,87.874-6.106,127.394c-9.315,18.79-18.504,37.44-26.016,57.057 c-8.024,20.952-14.973,42.34-20.937,63.968c-5.358,19.43-10.173,39.207-12.573,59.248c-0.83,6.933-1.412,13.985-0.964,20.969 c0.186,2.906,0.699,5.663,1.317,8.502c0.418,1.924,2.35,8.439-0.951,7.768c-2.181-0.443-4.467-4.082-5.787-5.708 c-2.516-3.099-4.8-6.394-6.978-9.737c-4.462-6.846-8.808-14.04-10.882-22.015c-1.441-5.542-2.052-11.492-0.954-17.153 c1.301-6.713,5.617-10.236,9.155-15.606c5.342-8.108,7.277-19.765,7.191-29.335c-0.1-11.182-4.467-22.109-8.14-32.52 c-3.534-10.016-7.842-19.448-13.573-28.395c-10.358-16.169-22.977-30.909-35.911-45.057 c-25.691-28.103-38.702-64.692-40.044-102.604c-0.668-18.857,1.559-38.462,9.2-55.867c3.525-8.029,8.295-15.33,14.465-21.574 c7.366-7.455,16.209-12.36,25.178-17.562C267.624,141.668,276.007,135.085,283.497,127.029c0.492-0.529-0.472-1.325-0.965-0.795 c-8.672,9.328-18.525,16.186-29.51,22.434c-9.131,5.194-17.588,10.97-24.494,18.998c-11.086,12.886-16.557,29.842-18.994,46.419 c-5.71,38.837,3.192,82.448,25.44,114.988c9.356,13.685,21.817,25.235,32.239,38.104c6.929,8.556,13.6,17.398,19.294,26.832 c6.67,11.051,10.855,23.159,14.832,35.378c1.936,5.948,3.831,11.932,4.295,18.205c0.491,6.642-0.568,13.344-2.069,19.802 c-1.535,6.603-4.538,11.82-8.873,16.974c-3.044,3.619-4.851,7.806-5.517,12.484c-2.443,17.173,8.097,33.924,18.161,46.925 c1.543,1.994,5.904,8.775,9.197,8c3.819-0.9,0.598-9.863,0.218-11.801c-3.184-16.227,0.945-34.492,4.189-50.383 c9.537-46.733,24.748-93.651,45.618-136.571c7.295-15.002,15.788-29.478,20.05-45.732c6.02-22.957,6.857-47.523,3.3-70.941 c-3.708-24.411-12.371-47.686-22.785-69.968c-5.579-11.938-11.647-23.639-17.767-35.306c-0.933-1.778-3.205-9.221-6.653-8.991 c-4.128,0.274-4.609,8.78-9.574,6.899c-5.263-1.993-8.259-12.194-10.07-16.671c-4.296-10.621-7.147-21.786-11.708-32.299 c-2.349-5.414-7.927-15.889-12.208-5.974c-4.907,11.364-5.618,24.582-9.143,36.411c-1.645,5.52-3.598,11.393-7.465,15.784 C282.054,126.778,283.018,127.574,283.497,127.029z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiedBackground);
export default __webpack_public_path__ + "static/media/SiedBackground.37d1db4c6679e6e9666073ef95e76eb5.svg";
export { ForwardRef as ReactComponent };